<template>
    <div class="templatelist" v-if="templateItems.length > 0">
        <div class="list" v-for="item in templateItems" :key="item.id">
            <TemplateItem :template="item" type="category" />
        </div>
    </div>
    <el-pagination v-if="pagetotle > page.pageSize" style="margin-top: 20px; width: 100%;" background
        layout="prev, pager, next" small pager-count="5" :total="pagetotle" :page-size="page.pageSize"
        @change="pagechage" ref="pagination" />
    <div v-if="templateItems.length === 0" class="w-full h-full flex justify-center items-center">
        <el-empty description="暂无数据" />
    </div>
</template>

<script lang="ts" setup>
import { getmaterials } from '@/api/affairs'
import { ElInput, ElButton, ElCascader, ElEmpty } from 'element-plus'
// @ts-ignore
import TemplateItem from './TemplateItem.vue'
import { ref } from 'vue';
const page = ref({
    pageNum: 1,
    pageSize: 20,
    type: 1,
})

let keywords = '';
const pagetotle = ref(0);
const templateItems = ref([]);
let category_Id = '';
const getmaterialsList = (categoryId: string | number, resetNo: boolean, Searchkeywords: string = '') => {
    if (resetNo) {
        page.value.pageNum = 1;
    }
    category_Id = categoryId.toString();
    Searchkeywords = Searchkeywords.trim();
    let params = Object.assign({}, page.value, {
        "categoryId": category_Id,
        "keywords": Searchkeywords,
        hotType: 1,// 1, 模板，2, 素材，3, 图片，4, 字体
    })
    console.log(params)
    getmaterials(params).then(res => {
        pagetotle.value = res.data.data.total;
        templateItems.value = res.data.data.list;
        console.log('templateItems.value', res.data.data.list)
    }).catch(() => {
    })
}
const searchTemplates = (categoryId: string | number, keywords: string) => {
    getmaterialsList(categoryId, true, keywords);
}

const pagechage = (val: number) => {
    page.value.pageNum = val;
    page.value = Object.assign({}, page.value)
    console.log(page.value)
    getmaterialsList(category_Id, false, keywords);
}
defineExpose({
    searchTemplates,
    getmaterialsList,
});
</script>
<style lang="scss" scoped>
.templatelist {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 16px;

    .list {
        width: 140px;
    }
}
</style>
